import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import types from './types';
import enums from '~/utils/enums';

//= ============== SELECTOR ===============//
const loadStatus = (state) => state.getIn(['poc', 'loadStatus']);
const listPoc = (state) => state.getIn(['poc', 'listPoc']);
const paginate = (state) => state.getIn(['poc', 'paginate']);

export const selectors = {
    loadStatus,
    listPoc,
    paginate
};

//= ============== REDUCER ===============//
const initState = fromJS({
    loadStatus: enums.STATUS.LOADING,
    listPoc: [],
    paginate: {
        currentPage: 1,
        perPage: 1,
        total: 1
    }
});

const loading = (state) => state.set('loadStatus', enums.STATUS.LOADING);
const loadSuccess = (state) => state.set('loadStatus', enums.STATUS.SUCCESS);
const loadFail = (state) => state.set('loadStatus', enums.STATUS.FAIL);
const handleListPocSuccess = (state, action) => state.set('listPoc', fromJS(action.payload));

const reducer = handleActions({
    [types.FETCH_POC]: loading,
    [types.LOAD_SUCCESS]: loadSuccess,
    [types.LOAD_FAIL]: loadFail,
    [types.FETCH_POC_SUCCESS]: handleListPocSuccess
}, initState);

export default reducer;
